'use strict';
var APIRID = 0;
// This method returns a new unique apirid for this application scope.
const request_apirid = function() {
   APIRID++;
   return ''.concat( new Date().getTime(),'-',APIRID );
};// /request_apirid()

export default request_apirid;
